<div class="login-background">
  <div class="card login-container">
    <div class="card-header bp-card-header">
      <h3 class="login-header bp-text">Password Update</h3>
    </div>
    <div class="card-body">
      <form #loginForm="ngForm">
        <div class="form-group">
          <label for="tempPassword" class="bp-text login-label">{{changetypetext}} </label>
          <input [(ngModel)]="tempPassword" name="tempPassword" required type="password" class="form-control" id="tempPassword">
          <div *ngIf="failed" class="alert alert-danger">{{message}}</div>
        </div>
        <div class="form-group">
          <label for="inputPassword" class="bp-text login-label">New Password</label>
          <input [(ngModel)]="password" name="password" required type="password" class="form-control" id="inputPassword">
          <div *ngIf="password != confirmPassword" class="alert alert-danger">Password must match!!</div>
        </div>
        <div class="form-group">
          <label for="confirmPassword" class="bp-text login-label">Confirm Password</label>
          <input [(ngModel)]="confirmPassword" name="confirmPassword" required type="password" class="form-control" id="inputPasswordConfirm">
          <div *ngIf="password != confirmPassword" class="alert alert-danger">Password must match!!</div>
        </div>
        <button type="submit" [disabled]="!loginForm.form.valid" class="btn btn-primary login-btn bp-text" (click)="onChangePassClick(tempPassword, password, confirmPassword)">Change Password</button>
      </form>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.html